import Swiper from 'swiper';
import { Navigation, Thumbs, Zoom } from 'swiper/modules';
import anime from "animejs";
import {init360Images} from "../../../default/global/js/init360Images";

export function openFullscreenGallery(clickedElement, selectorImg = ".js-openGallery") {

    const showNavigation = true;

    function buildSwiperWrapper(medias) {
        let articleCard = false;
        if(document.body.classList.contains('card')) {
            articleCard = true;
        }
        const swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');
        for (let media of medias) {
            let mediaSlide = document.createElement('div');
            mediaSlide.classList.add('swiper-slide');
            const swiperslide = mediaSlide;
            if (articleCard) {
                mediaSlide = document.createElement('div');
                mediaSlide.classList.add('swiper-zoom-container');
                swiperslide.appendChild(mediaSlide);
            }
            switch (media.type) {
                case "video":
                case "embed":
                    mediaSlide.innerHTML = media.src;
                    break;
                case "viewer360":
                    mediaSlide.innerHTML = media.src;
                    break;
                case "image":
                    mediaSlide.innerHTML = "<img class='swiper-zoom-target' src='" + media.src + "' alt='" + media.src + "'/>";
                    break;
            }
            if (articleCard) {
                swiperWrapper.appendChild(swiperslide);
            } else {
                swiperWrapper.appendChild(mediaSlide);
            }
        }

        return swiperWrapper;
    }

    function buildFullscreenGallery() {
        const arrOriginals = [];
        const arrThumbs = [];
        const gallery = clickedElement.dataset.gallery;

        if (!gallery) {
            return false;
        }

        let count = 0;
        let lengthGalleries = document.querySelectorAll('fullscreenGallery');

        if (lengthGalleries) {
            count = lengthGalleries.length;
        }

        const id = "fullscreenGallery-" + count;

        let i = 0;
        for (let imagesFullscreen of document.querySelectorAll(selectorImg+"[data-gallery='"+gallery+"']")) {
            let img = imagesFullscreen.querySelector('img');
            let video = imagesFullscreen.querySelector('video');
            let embed = imagesFullscreen.querySelector('iframe');

            let objMedia = {};
            let objMediaThumb = {};
            let isInArray = false;
            let thumb = imagesFullscreen.dataset.thumb;

            if (img) {
                objMedia.type = "image";
                objMedia.src = imagesFullscreen.dataset.original;
                imagesFullscreen.setAttribute('data-gallery-id', id);
                if(thumb === undefined){
                    thumb = img.src;
                }
            }
            if (video) {
                video.style.width = "100%";
                video.setAttribute("autoplay",true);
                video.setAttribute("playsinline",true);
                video.removeAttribute("controls");
                objMedia.type = "video";
                objMedia.src = video.outerHTML;
            }
            if (embed) {
                objMedia.type = "embed";
                objMedia.src = embed.outerHTML;
            }

            if(imagesFullscreen.classList.contains("js-load360")){
                objMedia.type = "viewer360";
                objMedia.src = "<div class='viewer360' data-options='"+imagesFullscreen.dataset.options+"'></div>";
            }
            for (let insertedOrignal of arrOriginals) {
                if (insertedOrignal.src === objMedia.src) {
                    isInArray = true;
                    break;
                }
            }
            if(thumb){
                objMediaThumb.src = imagesFullscreen.dataset.thumb;
                objMediaThumb.type = "image";
            }
            if (!isInArray) {
                arrOriginals.push(objMedia);
                arrThumbs.push(objMediaThumb);
            }
            i++;
        }

        const fullgallery = document.createElement('div');
        fullgallery.classList.add('fullscreenSwiper');
        fullgallery.classList.add('fullscreenGallery');
        fullgallery.classList.add('is-loading');
        fullgallery.setAttribute('id', id);
        fullgallery.style.opacity = 0;

        //build gallery big images
        const galleryOriginalImages = document.createElement('div');
        galleryOriginalImages.classList.add('fullscreenSwiperImage');
        galleryOriginalImages.classList.add('swiper');

        //add images in big images wrapper
        const swiperWrapperOriginalImages = buildSwiperWrapper(arrOriginals);

        galleryOriginalImages.appendChild(swiperWrapperOriginalImages);

        if(showNavigation){
            let navigationElements = buildNavigation();
            galleryOriginalImages.appendChild(navigationElements[0]);
            galleryOriginalImages.appendChild(navigationElements[1]);
        }
        fullgallery.appendChild(galleryOriginalImages);

        if(arrOriginals.length > 1){
            //build gallery thumbs
            const galleryThumbs = document.createElement('div');
            galleryThumbs.classList.add('fullscreenSwiperThumbs');
            galleryThumbs.classList.add('swiper');
            //add images in thumbs wrapper
            const swiperWrapperThumbs = buildSwiperWrapper(arrThumbs);
            galleryThumbs.appendChild(swiperWrapperThumbs);

            fullgallery.appendChild(galleryThumbs);
        }

        //build gallery close button
        const galleryCloseButton = document.createElement('div');
        galleryCloseButton.classList.add('fullscreenSwiperClose');
        galleryCloseButton.innerHTML = "<i class=\"icon icon-close\"></i>";

        fullgallery.appendChild(galleryCloseButton);

        document.body.appendChild(fullgallery);

        return id;
    }

    function closeFullscreenGallery(gallery) {
        anime({
            targets: gallery,
            opacity: 0,
            easing: 'linear',
            duration: 400,
            complete: function () {
                gallery.remove();
                document.body.classList.remove('fullscreen-gallery-opened');
            }
        });
    }

    function getCurrentSlideIndex(clickedElement) {
        if (clickedElement.dataset.index) {
            return clickedElement.dataset.index;
        } else {
            return 0;
        }
    }

    function resizeMainSwiper(swiper) {
        swiper.wrapperEl.style.height = swiper.height + "px";
    }

    function buildNavigation(){
        //build prev and next button
        const prevBtn = document.createElement('div');
        prevBtn.classList.add('swiper-button-prev');
        prevBtn.innerHTML = "<i class=\"icon icon-angle-left\"></i>";

        const nextBtn = document.createElement('div');
        nextBtn.classList.add('swiper-button-next');
        nextBtn.innerHTML = "<i class=\"icon icon-angle-right\"></i>";

        return [
            prevBtn,
            nextBtn
        ];
    }

    function handleVideos(curr){
        const activeSlide = curr.slides[curr.activeIndex];
        for(let slide of curr.slides){
            const videoElement = slide.querySelector('video');
            if(videoElement){
                if(slide === activeSlide){
                    videoElement.play();
                    videoElement.muted = false;
                }else{
                    videoElement.pause();
                }
            }
        }
    }

    function handleViewer360(curr){
        const activeSlide = curr.slides[curr.activeIndex];
        init360Images(activeSlide.querySelectorAll('.viewer360'));
    }

    setTimeout(function () {
        let currentSlide = 0;
        let fullgalleryid = buildFullscreenGallery();
        currentSlide = getCurrentSlideIndex(clickedElement);

        let fullgallery = document.getElementById(fullgalleryid);

        if (fullgallery) {
            Swiper.use([Thumbs, Navigation, Zoom]);

            let galleryThumbs = false;

            if(document.querySelector('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs')){
                galleryThumbs = new Swiper('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    slideToClickedSlide: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    preloadImages: true,
                    initialSlide: parseInt(currentSlide),
                    navigation: {
                        nextEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs .swiper-button-next',
                        prevEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs .swiper-button-prev',
                    },
                    loop: false,
                    breakpoints: {
                        0: {
                            spaceBetween: 5,
                        },
                        768: {
                            spaceBetween: 10,
                        }
                    }
                });
            }

            let allowTouchMove = false;
            let touchRatio = 0;

            if (window.outerWidth < GLOBALS.gridBreakpoints.sm) {
                allowTouchMove = true;
                touchRatio = 1;
            }

            const galleryImage = new Swiper('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage', {
                loop: true,
                slidesPerView: 1,
                initialSlide: parseInt(currentSlide),
                preloadImages: true,
                zoom: {
                    maxRatio: 3,
                    minRatio: 1,
                    toggle: false,
                    // Desktop: gezoomtes Bild folgt der Maus. Ziehen bricht bei schmalen Bildern ab,
                    // wenn das gezoomte Bild nicht breiter als der Slide ist (Swiper-Randprüfung).
                    panOnMouseMove: true,
                },
                allowTouchMove: allowTouchMove,
                touchRatio: touchRatio,
                navigation: {
                    nextEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage .swiper-button-next',
                    prevEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage .swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
                on: {
                    afterInit: function () {
                        fullgallery.style.display = "";
                        anime({
                            targets: fullgallery,
                            opacity: 1,
                            easing: 'linear',
                            duration: 200,
                            complete: function () {
                                resizeMainSwiper(galleryImage);
                                document.body.classList.add('fullscreen-gallery-opened');
                                setTimeout(function () {
                                    fullgallery.classList.remove("is-loading");
                                }, 200);
                            }
                        });
                        handleVideos(this);
                        handleViewer360(this);
                    },
                    slideChange: function () {
                        handleVideos(this);
                        handleViewer360(this);
                        this.zoom.out();
                        this.allowTouchMove = true;
                    },
                    init() {
                        const swiperInstance = this;
                        swiperInstance.slides.forEach((slide) => {
                            const img = slide.querySelector('.swiper-zoom-target');
                            if (img) {
                                let startTime = 0;
                                let startX = 0;
                                let startY = 0;
                                let hasMoved = false;

                                const handlePointerDown = (e) => {
                                    startTime = Date.now();
                                    startX = e.clientX;
                                    startY = e.clientY;
                                    hasMoved = false;
                                };

                                const handlePointerMove = (e) => {
                                    const deltaX = Math.abs(e.clientX - startX);
                                    const deltaY = Math.abs(e.clientY - startY);

                                    if (deltaX > 8 || deltaY > 8) {
                                        hasMoved = true;
                                    }
                                };

                                const handlePointerUp = (e) => {
                                    const duration = Date.now() - startTime;
                                    const deltaX = Math.abs(e.clientX - startX);
                                    const deltaY = Math.abs(e.clientY - startY);

                                    if (duration < 500 && !hasMoved && deltaX <= 8 && deltaY <= 8 &&
                                        slide.classList.contains('swiper-slide-active')) {

                                        swiperInstance.zoom.toggle();
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                };

                                img.addEventListener('pointerdown', handlePointerDown);
                                img.addEventListener('pointermove', handlePointerMove);
                                img.addEventListener('pointerup', handlePointerUp);

                                img.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                });
                            }
                        });
                    },

                    zoomChange(swiper, scale) {
                        if (scale > 1) {
                            this.allowTouchMove = true;
                        }
                    }
                }
            });

            fullgallery.querySelector('.fullscreenSwiperClose').addEventListener('click', () => {
                closeFullscreenGallery(fullgallery);
            });
            document.addEventListener("keydown", handleKeyDown);

            function handleKeyDown(e) {
                if (e.key === "Escape") {
                    closeFullscreenGallery(fullgallery);
                }
                if (e.key === "ArrowLeft") {
                    galleryImage.slidePrev(200);
                }
                if (e.key === "ArrowRight") {
                    galleryImage.slideNext(200);
                }
            }
        }
    }, 200);
}
